import queryString from "query-string";

import { setLocalStorage, getLocalStorage } from "js/helpers/functions";
import { COLOR_PICKER_RECENT_PALETTE } from "core/localStorageKeys";

import { iconEditorPreviewEndpoint, iconEditorTokenEndpoint } from "data/links";

/* -------------------------------------------------------------------------- */
/*                                   COLORS                                   */
/* -------------------------------------------------------------------------- */

export const getPersistedRecentColorsPalette = () => {
    const persistedRecentPalette = getLocalStorage(COLOR_PICKER_RECENT_PALETTE);
    const persistedIconsColors =
        persistedRecentPalette && persistedRecentPalette.iconColorsRecent;
    const persistedBackgroundColors =
        persistedRecentPalette && persistedRecentPalette.backgroundColorsRecent;

    return {
        persistedRecentPalette,
        persistedIconsColors,
        persistedBackgroundColors
    };
};

export const setInitialColorStatesWithPersistedColors = ({
    state,
    persistedIconsColors,
    persistedBackgroundColors
}) => {
    const stateCopy = { ...state };

    if (persistedIconsColors) {
        stateCopy.iconColors.activeColor = persistedIconsColors[0];
        stateCopy.iconColors.recent = persistedIconsColors;
    }

    if (persistedBackgroundColors) {
        stateCopy.backgroundColors.activeColor = persistedBackgroundColors[0];
        stateCopy.backgroundColors.recent = persistedBackgroundColors;
    }

    return stateCopy;
};

export const persistUpdatedRecentColorsPalettes = ({
    updatedRecentIconColors = [],
    updatedRecentBackgroundColors = []
}) =>
    setLocalStorage(COLOR_PICKER_RECENT_PALETTE, {
        iconColorsRecent: [...updatedRecentIconColors],
        backgroundColorsRecent: [...updatedRecentBackgroundColors]
    });

/* -------------------------------------------------------------------------- */
/*                               EDITOR PREVIEW                               */
/* -------------------------------------------------------------------------- */

/* ---------------------------------- TOKEN --------------------------------- */

export const fetchToken = async () => {
    const response = await fetch(
        new URL(iconEditorTokenEndpoint, window.location.origin)
    );
    return response;
};

/* ------------------------------ PREVIEW IMAGE ----------------------------- */

export const fetchEditorPreviewImage = async ({ state, iconId }) => {
    const requestQueryString = generateQueryString({
        state,
        iconId: state.currentIconId || iconId
    });

    const requestUrl = `${iconEditorPreviewEndpoint({
        iconId: state.currentIconId
    })}?${requestQueryString}`;

    const editorPreviewResponse = await fetch(
        new URL(requestUrl, window.location.origin)
    );

    return editorPreviewResponse;
};

const generateQueryString = ({ state, iconId }) => {
    return queryString.stringify({
        foregroundColor: "#000000",
        foregroundOpacity: 1.0,
        backgroundShape: "square",
        backgroundShapeOpacity: 1,
        backgroundShapeColor: "#FFFFFF",
        rotation: state[iconId].rotation,
        flipX: state[iconId].flipX,
        flipY: state[iconId].flipY,
        token: state.token
    });
};
